import { reactive } from "@nuxtjs/composition-api";

// Module singleton so any flow (e.g. ModalTender after a designer-plan
// tender) can open the modal that is mounted elsewhere on the page.
// Plain reactive only: module-level computed/watch would freeze when the
// creating component unmounts.
const state = reactive({
  open: false,
  tenderId: null,
  tenderKey: null,
});

export function useSpecifyTenderModal() {
  function open({ tenderId, tenderKey }) {
    state.tenderId = tenderId;
    state.tenderKey = tenderKey;
    state.open = true;
  }

  function close() {
    state.open = false;
  }

  return {
    state,
    open,
    close,
  };
}
